<template>
	<div class="popup">
		<div class="colorList" v-if="colorShow">
			<span v-for="(i,index) in colors" :style="'background:'+i" :class="index==ClassIndex?'checkColor':''" @click="colorFn(index)"></span>
		</div>
		<div class="Dan" style="padding:0.1rem;">
			<span class="DanT" @click="colorSh()"></span>
			<input
				id = "DanC"
				class="DanC"
				type="text"
				autofocus=""
				placeholder="说点什么吧"
				:maxlength = "number"
				v-model="barrage"
				@input="inputChange($event)"
				style="border-radius: 0.1rem;background:#fff;"
				value="">
			</input>
			<van-button type="info" style="margin:0 0.1rem;border-radius:0.1rem;width:1.5rem;height:0.6rem;line-height:0.6rem;font-size:0.3rem;" size="normal" @click='sendBarrage'>发送</van-button>
		</div>
    	<span class="DanOver">还能输入：{{number-numberOver}}个字符</span>
		<div class="DanSend" id="DanSend">
			<div v-for="i in historyData" class="DanHistory">
				<p>{{i.barrage}}</p>
				<span></span>
			</div>
		</div>
	</div>
</template>

<script>
import Vue from 'vue';
import { Button,Toast,Notify } from 'vant';

Vue.use(Notify).use(Toast).use(Button);
export default {
	components: {
	},
	computed:{
		userID(){
			return localStorage.getItem("userid");//用户id
		}
	},
	data(){
		return{
			colors:['#ffffff','#000000','#e42732','#faf100','#27bee4','#2730e4','#27e446','#a827e4','#fa8700',],
			colorShow:false,
			ClassIndex:0,
			number:25,
			numberOver:0,
			userdata:"",
			barrage:'',
			historyData:[],
		}
	},
	methods:{
		colorFn(data){//选择颜色
			this.ClassIndex = data;
			this.colorShow = false;
		},
		colorSh(){
			this.colorShow = !this.colorShow;
		},
		// 判断内容是否为空
		isEmpty(param){
			if(param){
				var param_type = typeof(param);
				if(param_type == 'object'){
					//要判断的是【对象】或【数组】或【null】等
					if(typeof(param.length) == 'undefined'){
						if(JSON.stringify(param) == "{}"){
							return true;//空值，空对象
						}
					}else if(param.length == 0){
						return true;//空值，空数组
					}
				}else if(param_type == 'string'){
					//如果要过滤空格等字符
					var new_param = param.trim();
					if(new_param.length == 0){
						//空值，例如:带有空格的字符串" "。
						return true;
					}
				}else if(param_type == 'boolean'){
					if(!param){
						return true;
					}
				}else if(param_type== 'number'){
					if(!param){
						return true;
					}
				}
				return false;//非空值
			}else{
				//空值,例如：
				//(1)null
				//(2)可能使用了js的内置的名称，例如：var name=[],这个打印类型是字符串类型。
				//(3)空字符串''、""。
				//(4)数字0、00等，如果可以只输入0，则需要另外判断。
				return true;
			}
		},
		inputChange(data){
			this.numberOver = data.target.value.length
		},
		sendBarrage(){
			if(this.isEmpty(this.barrage)==false){
					if(this.userdata){
						var prama = {
							activityId:1,
							userId :this.userID,
							name:this.userdata.name,
							barrage:this.barrage,
							color:this.colors[this.ClassIndex]
						}
					}else{
						var prama = {
							activityId:1
						}
					}
				
				this.axios.post('https://party.blueiec.com/annual-meeting/qyactivitybarrage/sendBarrage',prama)
				.then(res=> {
					console.log(res)
					if(res.data.code==0){
						Notify({ type: 'success', message: '成功发送' })
						this.historyXinxi();//查询历史信息
					}else{
						Notify({ type: 'warning', message: res.data.msg })
					}
					this.numberOver = ''
					this.barrage = ''
				})
			}else{
				Toast.fail('内容不可以为空');
			}
		},
		querySignInfo(){
			this.axios.get('https://party.blueiec.com/annual-meeting/qy/querySignInfo?userId='+this.userID+'&activityId=1')
			.then(res=> {
				this.userdata = res.data.user
			})
		},
		historyXinxi(){//查询历史弹幕信息
			var prama = {
				activityId:1,
				userId :this.userID,
			}
			this.axios.post('https://party.blueiec.com/annual-meeting/qyactivitybarrage/queryHistoryBarrage',prama)
			.then(res=> {
				this.historyData=res.data.history
				this.scrollEnd();
			})
		},
		scrollEnd(){//滚动条滚动到最后面
			var ele = document.getElementById('DanSend');
			ele.scrollTop = ele.scrollHeight;
		},
	},
	mounted(){
		const windowHeight = window.innerHeight
		var input = document.getElementById('DanC')
		input.addEventListener('blur', function () {
			let windowFocusHeight = window.innerHeight
			if (windowHeight == windowFocusHeight) {
			return
			}
			
			let currentPosition;
			let speed = 1; //页面滚动距离
			currentPosition = document.documentElement.scrollTop || document.body.scrollTop;
			currentPosition -= speed;
			window.scrollTo(0, currentPosition); //页面向上滚动
			currentPosition += speed; //speed变量
			window.scrollTo(0, currentPosition); //页面向下滚动
		})
		this.historyXinxi()
		this.querySignInfo();
		this.scrollEnd();
	}
}
</script>

<style>
.popup{
	background: url('../assets/img/mobBackground.jpg') repeat center;
	background-size: auto 100%;
	display: block;
	width:100% ;
	height: calc(100vh - 2rem);
	position: fixed;top:1rem;left:0;width:100%;
}
.Dan .van-button{
	background: url('../assets/img/btnbg.png');
	background-size: cover;
	border: 1px solid transparent;
}
.Dan input{padding-left:8px;}
.Dan{
	display: flex;
	flex-direction:row;
	flex-wrap: nowrap;
	justify-content: space-between;
	height:0.8rem;
	width: 100%;
	line-height:0.8rem;
	font-size: 0.26rem;
	border-bottom:  1px solid #efefef;
	background:#efebea;
	position: absolute;
	bottom: 1rem;
	box-sizing: border-box;
	z-index: 100;
	position: absolute;
	bottom: 0;
	left: 0;
}
.DanT{
	text-align: left;
	/* flex-grow:1; */
	background: #fff;
	color: #000;
	display: inline-block;
	width: 0.6rem;
	height: 0.6rem;
	
	background: url('../assets/img/yuyin.png') no-repeat;
	background-size: 100% 100%;
	margin: 0 0.1rem;
}
.DanC{
	text-align: left;
	flex-grow:7;
	line-height:0.6rem;
	height:0.6rem;
	color: #999;
	padding-left:0.5rem;
	background:#fff;
}
.DanOver{
	display: block;
	color: #fff;
	height:1rem;
	width: 94%;
	margin-left: 3%;
	line-height:1rem;
	font-size: 0.26rem;
	text-align: right;
	position: absolute;
	bottom: 0.8rem;
}
.DanSend{
	width: 100%;
	height: 1rem;
	justify-content: center;
	align-items: center;
	height: calc(100vh - 2.8rem);
	overflow-y:scroll;
	padding-bottom: 0.8rem;
	box-sizing: border-box;
	/* display: flex;
	justify-content: flex-end;
	flex-direction: column; */
}
.DanHistory{
	display: flex;
	justify-content:flex-end;
	width: 100%;
	margin: 0.3rem 0;
}
.DanHistory>span{
	display: inline-block;
	width: 1rem;
	height: 1rem;
	background: url('../assets/img/fu.png') no-repeat center;
	background-size: cover;
	margin: 0 0.1rem;
}
.DanHistory>p{
	display: inline-block;
	width: 70%;
	background:#eedc7d;
	color: #00153b;
	font-size: 0.3rem;
	line-height: 0.4rem;
	margin: 0;
	padding: 0.2rem;
	border-radius: 0.2rem;
	margin-right:0.3rem; 
	position: relative;
	box-sizing: border-box;
}
.DanHistory>p::after{
	display: inline-block;
	content:'';
	width:0;
	height: 0;
	border-left: 0.2rem solid #eedc7d;
	border-top: 0.2rem solid rgba(0,0,0,0);
	border-bottom: 0.2rem solid rgba(0,0,0,0);
	border-right: 0.2rem solid rgba(0,0,0,0);
	position: absolute;
	right: -0.35rem;
	top: 0.3rem;
}
.colorList{
	display: flex;
	flex-direction:row;
	flex-wrap: nowrap;
	justify-content: space-around;
	align-items:center;
	color: #f29600;
	height:1rem;
	width: 100%;
	line-height:1rem;
	font-size: 0.26rem;
	text-align: right;
	position: absolute;
	bottom: 0.8rem;
	background: #efebea;
	z-index: 200;
	border-bottom: 1px solid #ccc;
}
.colorList span{
	display: inline-block;
	width: 0.6rem;
	height: 0.6rem;	
	border-radius: 50%;
}
.checkColor{
	border: 2px solid #00153b;
}
/* .DanSend span{
	text-align: center;
	background: #0068b6;
	color: #fff;
	display: inline-block;
	width: 3rem;
	height: 0.8rem;
	line-height: 0.8rem;
	font-size: 0.28rem;
	border-radius: 0.2rem;
	position: absolute;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	margin: auto;
} */
</style>


// WEBPACK FOOTER //
// src/components/popup.vue